import template from './formWarning.template.html';

export default {
controller: class controller {
    constructor($state, $mdMedia, $mdDialog, eventService, changesService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onFormWarning(function (_params) {
          $mdDialog
            .show({
              locals: {
                toState: _params.toState,
                toParams: _params.toParams
              },
              template,
              controllerAs: '$ctrl',
              controller: function ($mdDialog, toState, toParams) {
                'ngInject';
                var ctrl = this;
                ctrl.toState = toState;
                ctrl.toParams = toParams;
                ctrl.confirm = function () {
                  changesService.reset();
                  $mdDialog.hide({ toState: ctrl.toState, toParams: ctrl.toParams });
                };
                ctrl.cancel = function () {
                  $mdDialog.cancel();
                };
              }
            })
            .then(function (result) {
              $state.transitionTo(result.toState, result.toParams);
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
